export interface Textletter_Interface {
  id:number,
  subject_id:number,
  subject_title:String,
  dsc:string,
  code:string,
  semat:string,
  name:string,
  persianDate:string,
  username:string,
  del:boolean,
}

export function Empty_Textletter_Interface():Textletter_Interface{
  return{
    id:0,
    subject_id:0,
    subject_title:'',
    dsc:'',
    code:'',
    semat:'',
    name:'',
    persianDate:'',
    username:'',
    del:false
  }
}
